import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import { PERMISOS } from "@/helpers/permisos";

Vue.use(VueRouter);

// Code splitting dinámico
const Login = () => import("@/components/Login.vue");
const ResetPassword = () => import("@/components/auth/ResetPassword.vue");
const MainLayout = () => import("@/components/layout/MainLayout.vue");
const MainMap = () => import("@/components/map/Main.vue");
const Recursos = () => import("@/components/recursos/Recursos.vue");
const Guardias = () => import("@/components/guardias/Guardias.vue");
const Infraestructuras = () =>
  import("@/components/infraestructuras/Infraestructuras.vue");
const ListadoEmergencias = () =>
  import("@/components/listadoEmergencias/ListadoEmergencias.vue");
const HistoricoEmergenciaDespachos = () =>
  import("@/components/listadoEmergencias/HistoricoEmergenciaDespachos.vue");
const HistoricoRecursoDespachos = () =>
  import("@/components/despacho_recursos/HistoricoRecursoDespachos.vue");
const Administracion = () =>
  import("@/components/listadoUsuarios/Administracion.vue");
const DespachoRecursos = () =>
  import("@/components/despacho_recursos/DespachoRecursos.vue");
const TrackHistoryWindow = () =>
  import("@/components/tracksHistory/TrackHistoryWindow.vue");
const gestionDispositivosSeguimiento = () =>
  import("@/components/dispositivos_seguimiento/DispositivosSeguimiento.vue");
const HistoricoIncidente = () =>
  import("@/components/historico_incidente/HistoricoIncidente.vue");
const PlanificacionGantt = () =>
  import("@/components/planificacion/PlanificacionGantt.vue");
const NotFound = () => import("@/components/NotFound.vue");
const DashboardList = () => import("@/components/dashboards/DashboardList.vue");
const DashboardViewer = () =>
  import("@/components/dashboards/DashboardViewer.vue");

const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      title: "Login - Emergencia",
    },
  },
  {
    path: "/reset_password",
    name: "ResetPassword",
    component: ResetPassword,
    meta: {
      title: "Restablecer Contraseña - Emergencia",
    },
  },
  {
    path: "/",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "Map",
        component: MainMap,
        meta: {
          title: "Mapa - Emergencia",
        },
      },
      {
        path: "despacho_recursos",
        name: "DespachoRecursos",
        component: DespachoRecursos,
        meta: {
          title: "Despacho de Recursos - Emergencia",
          permission: [PERMISOS.PERMITIR_DESPACHO_RECURSOS],
        },
      },
      {
        path: "planificacion",
        name: "PlanificacionGantt",
        component: PlanificacionGantt,
        meta: {
          title: "Planificación - Emergencia",
          permission: [PERMISOS.VISUALIZAR_PLANIFICACION],
        },
      },
      {
        path: "recursos",
        name: "Recursos",
        component: Recursos,
        meta: {
          title: "Recursos - Emergencia",
          permission: [PERMISOS.VISUALIZAR_GESTION_MEDIOS],
        },
      },
      {
        path: "guardias",
        name: "Guardias",
        component: Guardias,
        meta: {
          title: "Guardias - Emergencia",
          permission: [PERMISOS.VISUALIZAR_HOJA_GUARDIAS],
        },
      },
      {
        path: "infraestructuras",
        name: "Infraestructuras",
        component: Infraestructuras,
        meta: {
          title: "Infraestructuras - Emergencia",
          permission: [PERMISOS.VISUALIZAR_GESTION_INFRAESTRUCTURAS],
        },
      },
      {
        path: "listado_emergencias",
        name: "ListadoEmergencias",
        component: ListadoEmergencias,
        meta: {
          title: "Gestion Incidentes - Emergencia",
          permission: [PERMISOS.VISUALIZAR_INCIDENTES],
        },
      },
      {
        path: "/listado_emergencias/:id",
        name: "DespachoEmergenciaDetalle",
        component: HistoricoEmergenciaDespachos,
        props: true,
        meta: {
          title: "Detalles de Emergencia - Emergencia",
          permission: [PERMISOS.PERMITIR_DESPACHO_RECURSOS],
        },
      },
      {
        path: "/despacho_recursos/:id",
        name: "DespachoRecursoDetalle",
        component: HistoricoRecursoDespachos,
        props: true,
        meta: {
          title: "Detalles de Recurso - Emergencia",
          permission: [PERMISOS.PERMITIR_DESPACHO_RECURSOS],
        },
      },
      {
        path: "historico_recurso",
        name: "HistoricoRecurso",
        component: HistoricoRecursoDespachos,
        meta: {
          title: "Histórico de Recurso - Emergencia",
          permission: [PERMISOS.VER_HISTORICO_RECURSO],
        },
      },
      {
        path: "/administracion",
        name: "Administracion",
        component: Administracion,
        meta: {
          title: "Gestion Usuarios - Emergencia",
          permission: [PERMISOS.VER_ROLES],
        },
      },
      {
        path: "/despacho_recursos",
        name: "DespachoRecursos",
        component: DespachoRecursos,
        meta: {
          title: "Despacho de Recursos - Emergencia",
          permission: [PERMISOS.VER_RECURSOS],
        },
      },
      {
        path: "/tracks_history/:id?",
        name: "TracksHistoryWindow",
        component: TrackHistoryWindow,
        props: true,
        meta: {
          title: "Historial de Tracks - Emergencia",
          permission: [PERMISOS.VISUALIZAR_HISTORICO_TRACKS],
        },
      },
      {
        path: "gestion_dispositivos_seguimiento",
        name: "GestionDispositivosSeguimiento",
        component: gestionDispositivosSeguimiento,
        meta: {
          title: "Dispositivos de Seguimiento - Emergencia",
          permission: [PERMISOS.VISUALIZAR_GESTION_DISPOSITIVOS_SEGUIMIENTO],
        },
      },
      {
        path: "/historico_incidente/:id",
        name: "HistoricoIncidente",
        component: HistoricoIncidente,
        props: true,
        meta: {
          title: "Historial del Incidente - Emergencia",
          permission: [PERMISOS.PERMITIR_HISTORICO_INCIDENTE],
        },
      },
      {
        path: "dashboards",
        name: "DashboardList",
        component: DashboardList,
        meta: {
          title: "Dashboards - Emergencia",
          permission: [PERMISOS.VISUALIZAR_DASHBOARDS],
        },
      },
      {
        path: "dashboard/:id",
        name: "DashboardViewer",
        component: DashboardViewer,
        props: true,
        meta: {
          title: "Dashboard - Emergencia",
          permission: [PERMISOS.VISUALIZAR_DASHBOARDS],
        },
      },
    ],
  },
  {
    path: "*",
    component: NotFound,
    meta: {
      title: "Página no encontrada - Emergencia",
    },
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

const publicRoutes = ["Login", "ResetPassword"];

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters["auth/isAuthenticated"];

  const isPublic = to.matched.some((record) =>
    publicRoutes.includes(record.name)
  );

  if (!isAuthenticated && !isPublic) {
    return next("/login");
  }

  if (isAuthenticated && isPublic) {
    return next("/");
  }

  const requiredPermissions = to.matched.flatMap(
    (record) => record.meta.permission || []
  );

  if (requiredPermissions.length > 0) {
    const hasPermission = store.getters["auth/hasPermiso"](requiredPermissions);

    if (!hasPermission) {
      return next("/");
    }
  }

  next();
});

router.afterEach((to) => {
  const defaultTitle = "Emergencia";
  const title = to.meta?.title || defaultTitle;
  document.title = title;
});

export default router;
